import { HttpErrorResponse, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { MngMessageService } from '@mng/mng-message-handler';
import { tap } from 'rxjs/operators';
import { MGS_LOGIN_URL } from './mgs-webapi.service';
import { looksLikeHtml, readBlobAsJSON, SERVER_ERROR_MESSAGE } from '@mng/mng-ts-helpers';
import { AuthService } from './auth/auth.service';

export function errorHandlingInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  const messageService = inject(MngMessageService);

  const authService = inject(AuthService);

  async function errorHandling(err: any, req: HttpRequest<unknown>) {
    console.log('Error URL', req.url);

    if (err instanceof HttpErrorResponse) {
      const istFehlerIndikatorFuerNotwendigePasswortAenderung =
        MGS_LOGIN_URL === req.url && err.status === HttpStatusCode.Forbidden;

      if (!istFehlerIndikatorFuerNotwendigePasswortAenderung) {
        // if (err.status !== HttpStatusCode.NotFound && err.status !== HttpStatusCode.Unauthorized && err.status !== HttpStatusCode.Forbidden) {
        if (err.status !== HttpStatusCode.Unauthorized && err.status !== HttpStatusCode.Forbidden) {
          const message = await getErrorMessage(err);
          void messageService.showError(message ?? 'Es ist ein Fehler aufgetreten');
        }

        if (err.status === HttpStatusCode.Unauthorized || err.status === HttpStatusCode.Forbidden) {
          console.log('HTTP Status Code', err.status, ' automatisches Logout');
          authService.tryLogout();
        }
      }
    }
  }

  return next(request).pipe(tap({ error: (err) => errorHandling(err, request) }));
}

export async function getErrorMessage(err: HttpErrorResponse): Promise<string> {
  if (err.error) {
    if (typeof err.error === 'string' && looksLikeHtml(err.error)) {
      return SERVER_ERROR_MESSAGE;
    }

    let messagesObject = err.error.messages && err.error.messages.length > 0 ? err.error : undefined;

    if (!messagesObject && err.error instanceof Blob) {
      const jsonFromBlob = await readBlobAsJSON(err.error);
      if (jsonFromBlob?.messages) {
        messagesObject = jsonFromBlob;
      }
    }

    if (messagesObject?.messages && messagesObject.messages.length > 0) {
      const errorMessage = messagesObject.messages[0];
      if (typeof errorMessage === 'string') {
        return errorMessage;
      }

      if (errorMessage['message']) {
        return errorMessage['message'];
      }
    }

    const message = err.error.detail
      ? err.error.detail
      : err.error.detailMessage
        ? err.error.detailMessage
        : err.error.message;
    return message ? message.replace(/\[.*\]/, '').trim() : err.message;
  } else {
    return err.message;
  }
}
